// Lógica financeira central do Motor Comercial (fonte única de verdade no frontend).
// A mesma fórmula está espelhada na edge function `comercial-admin` para persistência.
// NÃO alterar aqui sem alterar lá (e vice-versa).

export interface FinanceiroResult {
  valor: number | null;
  custoTotal: number | null;
  lucro: number | null;
  margem: number | null;
  probabilidade: number | null;
  pipelinePonderado: number | null;
  lucroPonderado: number | null;
  margemTone: 'verde' | 'amarela' | 'vermelha' | null;
  temCustos: boolean;
}

export const MARGEM_META_DEFAULT = 30;
export const MARGEM_ATENCAO = 20;

function toNum(v: number | string | null | undefined): number | null {
  if (v == null) return null;
  if (typeof v === 'string' && v.trim() === '') return null;
  const n = Number(v);
  return Number.isNaN(n) ? null : n;
}

export function calcularFinanceiro(
  valor: number | string | null | undefined,
  custos: Record<string, number | string | null | undefined> | null | undefined,
  probabilidade: number | string | null | undefined,
  metaMargem: number = MARGEM_META_DEFAULT,
): FinanceiroResult {
  const valorNum = toNum(valor);

  const probRaw = toNum(probabilidade);
  const prob = probRaw != null ? Math.max(0, Math.min(100, probRaw)) : null;

  let custoTotal: number | null = null;
  let temCustos = false;
  if (custos && typeof custos === 'object') {
    const valores = Object.values(custos)
      .map((v) => toNum(v))
      .filter((n): n is number => n != null && n > 0);
    if (valores.length > 0) {
      temCustos = true;
      custoTotal = Math.round(valores.reduce((s, n) => s + n, 0) * 100) / 100;
    }
  }

  // Sem custo informado => lucro/margem NÃO são calculados (não inventar).
  let lucro: number | null = null;
  let margem: number | null = null;
  if (valorNum != null && valorNum > 0 && custoTotal != null) {
    lucro = Math.round((valorNum - custoTotal) * 100) / 100;
    margem = Math.round((lucro / valorNum) * 1000) / 10;
  }

  const pipelinePonderado = valorNum != null && prob != null ? Math.round(valorNum * prob) / 100 : null;
  const lucroPonderado = lucro != null && prob != null ? Math.round(lucro * prob) / 100 : null;

  const margemTone = margem != null
    ? (margem >= metaMargem ? 'verde' : margem >= MARGEM_ATENCAO ? 'amarela' : 'vermelha')
    : null;

  return {
    valor: valorNum,
    custoTotal,
    lucro,
    margem,
    probabilidade: prob,
    pipelinePonderado,
    lucroPonderado,
    margemTone,
    temCustos,
  };
}